import { IconButton, Modal } from "@material-ui/core";
import { ChevronLeft } from "@material-ui/icons";
import React from "react";

interface FullScreenModelProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export const FullScreenModal = (props: FullScreenModelProps): JSX.Element => {
  const { open, onClose, title, children } = { ...props };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="bg-app-white h-full flex flex-col">
        <div className="flex border-b-8 border-app-gray-08 p2 items-center">
          <div>
            <IconButton onClick={onClose}>
              <ChevronLeft />
            </IconButton>
          </div>
          <div
            id="mobile-filter-title"
            className="text-display-title text-color-secondary"
          >
            {title}
          </div>
        </div>
        <div className="border-b border-app-gray-08 overflow-scroll">
          {children}
        </div>
      </div>
    </Modal>
  );
};
